export default __webpack_public_path__ + "static/media/timelapse-of-a-large-manufacturing-facility-SBV-318738238-HD.c5a719ad.mp4";